import apiHelper from "./apiHelper"
import axios from "axios"
import { API_ROUTES } from "../utils/constants"

export function createBot(data) {
    return apiHelper({ method: "post", path: API_ROUTES.AUDIO_BOT.CREATE_BOT, data: data })
}

export function editBot(data) {
    return apiHelper({ method: "post", path: API_ROUTES.AUDIO_BOT.EDIT_BOT, data: data })
}

export function connectBot(botId) {
    return apiHelper({ method: "post", path: API_ROUTES.AUDIO_BOT.CONNECT_BOT, data: { botId } })
}

export function disconnectBot(botId) {
    return apiHelper({ method: "post", path: API_ROUTES.AUDIO_BOT.DISCONNECT_BOT, data: { botId } })
}

export function reconnectBot(botId) {
    return apiHelper({ method: "post", path: API_ROUTES.AUDIO_BOT.RECONNECT_BOT, data: { botId } })
}

export function extendBot(botId) {
    return apiHelper({ method: "post", path: API_ROUTES.AUDIO_BOT.EXTEND_BOT, data: { botId } })
}

export function deleteBot(botId) {
    return apiHelper({ method: "delete", path: API_ROUTES.AUDIO_BOT.DELETE_BOT, data: { botId } })
}

export function activateBot(botId) {
    return apiHelper({ method: "post", path: API_ROUTES.AUDIO_BOT.ACTIVATE_BOT, data: { botId } })
}

export function suspendBot(botId) {
    return apiHelper({ method: "post", path: API_ROUTES.AUDIO_BOT.SUSPEND_BOT, data: { botId } })
}

export function changeBotPlaying(data) {
    return apiHelper({ method: "post", path: API_ROUTES.AUDIO_BOT.CHANGE_PLAYING, data })
}

export function startAllBots(selecteds) {
    return apiHelper({ method: "post", path: API_ROUTES.AUDIO_BOT.CONNECT_BULK, data: { selecteds } })
}
export function stopAllBots(selecteds) {
    return apiHelper({ method: "post", path: API_ROUTES.AUDIO_BOT.DISCONNECT_BULK, data: { selecteds } })
}
export function restartAllBots(selecteds) {
    return apiHelper({ method: "post", path: API_ROUTES.AUDIO_BOT.RECONNECT_BULK, data: { selecteds } })
}

export function changeVolume(token, data) {
    return new Promise((resolve, reject) => {
        let config = {
            method: "post",
            maxBodyLength: Infinity,
            url: `${API_ROUTES.CHANGE_VOLUME}?token=${token}`,
            data,
        }

        axios
            .request(config)
            .then((res) => {
                resolve(res.data)
            })
            .catch((err) => {
                console.error(err)
                reject(err)
            })
    })
}
